import React from "react";
import Header from "00Header";
import SectionOne from "01Section";
// import SectionTwo from "02Section";
import About from "03About";
import Stats from "04Stats";
import NewsLeterInfo from "05Section";
import MeetTheTeam from "06MeetTheTeam";
import FAQ from "07FAQ";
import Sponsorship from "08Sponsorship";
import Footer from "09Footer";
import { BrowserRouter } from "react-router-dom";

export default function App() {
  return (
    <div className="body">
      <BrowserRouter>
        <Header />
        <SectionOne />
        {/* <SectionTwo /> */}
        <About />
        <Stats />
        <NewsLeterInfo />
        <MeetTheTeam />
        <FAQ />
        <Sponsorship />
        <Footer />
      </BrowserRouter>
    </div>
  );
}
